const clickOutsideSymbol = Symbol('click-outside');
export const ClickOutside = {
  bind(element, binding) {
      const onBodyClick = (event) => {        
      if (typeof binding.value === 'function' && !event.composedPath().includes(element)) {
        binding.value(event);
      }
    };

    element[clickOutsideSymbol] = {onBodyClick};

    document.body.addEventListener('click', onBodyClick);
  },

  unbind(element) {
    const {onBodyClick} = element[clickOutsideSymbol];
    document.body.removeEventListener('click', onBodyClick);
  },
};
